import { useSelector } from "react-redux";
import ProductItemsList from "../productItemsList/productItemsList";
import SyncLoader from "react-spinners/SyncLoader";
import { css } from "@emotion/react";
import { useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";


const ProductsContainer = ({ category, categoryIndex, loading }) => {

    const subCategories = useSelector((state) => state.featuredProducts.categories[categoryIndex].subCategories);
    const [color, setColor] = useState("#000000");
    const history = useHistory();

    const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
  `;

    return (
        <>
            <div className="product-tab-wrap">
                <div className="product-head-wrap d-flex flex-column flex-md-row align-items-center justify-content-between mt-5">
                    <h1>{category && category.name ? category.name.charAt(0).toUpperCase() + category.name.slice(1) : ''} Listing</h1>
                    <nav>
                        <div className="nav nav-tabs" id="nav-tab" role="tablist">
                            {subCategories ? subCategories.slice(0, 4).map((subCategory, index) => {
                                return (
                                    // <li className="nav-item" key={index}>
                                    <a key={index} className={`nav-link ${index === 0 ? "active" : ""}`} id={`nav-${subCategory._id}-tab`} data-toggle="tab" href={`#elem-${subCategory._id}`} role="tab" aria-controls={`${subCategory._id}`} aria-selected={`${index === 0 ? "true" : "false"}`}>{`${subCategory.name} `}</a>
                                    // </li>
                                );
                            }) : ""}
                            {!loading && <Link to={`/search-result?categoryId=${category._id}`} className="nav-link show-more">{"Show More >>"}</Link>}
                        </div>
                    </nav>
                </div>
                <div className="tab-content" id="nav-tabContent">
                    {subCategories && subCategories.map((subCategory, index) => {
                        return (
                            <div className={`tab-pane ${index === 0 ? "show active" : ""}`} id={`elem-${subCategory._id}`} aria-labelledby={`nav-${subCategory._id}-tab`} role="tabpanel" key={index}>
                                <div className="row">
                                    {loading && <SyncLoader color={color} loading={loading} css={override} size={11} />}
                                    {!loading && <ProductItemsList categoryIndex={categoryIndex} subCategoryIndex={index} />}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
            {/* <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a class="nav-link active" id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab" aria-controls="nav-home" aria-selected="true">Home</a>
                <a class="nav-link" id="nav-profile-tab" data-toggle="tab" href="#nav-profile" role="tab" aria-controls="nav-profile" aria-selected="false">Profile</a>
                <a class="nav-link" id="nav-contact-tab" data-toggle="tab" href="#nav-contact" role="tab" aria-controls="nav-contact" aria-selected="false">Contact</a>
            </div>
        </nav>
        <div class="tab-content" id="nav-tabContent">
            <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                Home Tab
            </div>
            <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                Profile Tab
            </div>
            <div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                Contact Tab
            </div>
        </div> */}
        </>
    );
}

export default ProductsContainer;